(ns ui.view.survey.modals.select-sheet
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.alert.view :as alert]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.input.checkbox-group :as checkbox-group]
   [ui.components.modal.view :as modal]
   [ui.view.survey.event :as survey-view-event]
   [ui.view.survey.modals.event :as event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn select-sheet-body
  [{:keys [survey-id _lang selected-sheets selected-sheets-options confirmed? no-answers?
           multi-survey?]}]
  [:div
   [:div
    {:class "py-4 flex flex-col gap-4 items-center justify-center"}
    [:div
     {:class "flex flex-col gap-4 w-85"}
     [:p
      {:class ""}
      (loc/tr :survey-import-select-sheet-info-1)]
     [:p
      {:class ""}
      (loc/tr :survey-import-select-sheet-info-2)]
     [checkbox-group/view
      {:value       selected-sheets
       :options     selected-sheets-options
       :horizontal? false
       :on-change   (fn [sheets]
                      (rf/dispatch [::event/set-selected-sheets survey-id sheets]))}]]
    (when-not no-answers?
      [alert/warning
       {}
       [:div
        {:class "flex flex-col"}
        [:p
         {:class "font-semibold text-sm leading-6"}
         (loc/tr :survey-import-select-sheet-warning-1)]
        [:p
         {:class "font-semibold text-sm leading-6"}
         (if multi-survey?
           (loc/tr :survey-import-select-sheet-warning-2)
           (loc/tr :survey-import-select-sheet-warning-company))]
        (when multi-survey?
          [:p
           {:class "font-semibold text-sm leading-6"}
           (loc/tr :survey-import-select-sheet-warning-3)])
        [:div
         {:class "flex flex-row gap-4"}
         [:label
          {:class "text-[14px] text-warning-light-text-accent font-semibold flex flex-row gap-2"}
          [checkbox/view
           {:value     confirmed?
            :on-change (fn [checked?]
                         (rf/dispatch [::survey-view-event/confirm-sheet-selection survey-id checked?]))}]
          (loc/tr :survey-import-select-sheet-confirm)]]]])]])


(defn select-sheet-footer
  [{:keys [survey-id lang selected-sheets confirmed? no-answers?]}]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::survey-view-event/close-selecting-sheets-modal survey-id]))}
     (loc/tr :cancel nil lang)]]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/primary-solid
     {:on-click  (fn [_]
                   (rf/dispatch [::survey-view-event/import-tesi-custom-excel survey-id]))
      :disabled? (or (empty? selected-sheets)
                     (and
                      (not no-answers?)
                      (not confirmed?)))
      :tooltip   (when (empty? selected-sheets) (loc/tr :survey-import-select-sheet-tooltip))}
     (loc/tr :survey-import-continue)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])
        selected-sheets @(rf/subscribe [::survey-view-sub/selected-sheets survey-id])
        selected-sheets-options @(rf/subscribe [::survey-view-sub/selected-sheets-options survey-id])
        confirmed? @(rf/subscribe [::survey-view-sub/sheet-selection-confirmed? survey-id])
        no-answers? @(rf/subscribe [::survey-view-sub/no-answers? survey-id])
        multi-survey? @(rf/subscribe [::survey-view-sub/multi-survey? survey-id])]
    [modal/view
     {:visible? @(rf/subscribe [::survey-view-sub/selecting-sheets? survey-id])
      :hide!    #(rf/dispatch [::survey-view-event/close-selecting-sheets-modal survey-id])
      :size     :full}
     (loc/tr :survey-import-select-sheets)
     [select-sheet-body {:survey-id               survey-id
                         :lang                    lang
                         :selected-sheets         selected-sheets
                         :selected-sheets-options selected-sheets-options
                         :confirmed?              confirmed?
                         :no-answers?             no-answers?
                         :multi-survey?           multi-survey?}]
     [select-sheet-footer {:survey-id       survey-id
                           :lang            lang
                           :selected-sheets selected-sheets
                           :confirmed?      confirmed?
                           :no-answers?     no-answers?}]]))
